import sanitizeHtml from "sanitize-html";

export const stripHtmlTags = (value = "") => {
  const sanitized = sanitizeHtml(value, {
    allowedTags: [],
    allowedAttributes: {}
  });

  return sanitized.replace(/\s+/g, " ").trim();
};
